import { Link } from 'react-router'
import { Reveal, Section, SectionHeading } from '@/components/primitives'

const CONTROLS = [
  {
    id: 'SCOPE',
    name: 'Account scope',
    detail: 'Every record and action stays inside your account boundary.',
  },
  {
    id: 'ROLES',
    name: 'Roles and masking',
    detail: 'You decide what each person can see and do, including sensitive fields.',
  },
  {
    id: 'AUDIT',
    name: 'Audit and approvals',
    detail: 'Views, changes, exports, and workflow publishes leave a record.',
  },
]

export function TrustSection() {
  return (
    <Section labelledBy="trust-heading">
      <Reveal>
        <SectionHeading
          id="trust-heading"
          title="Control the system. Prove every change."
          copy="Flexibility for operators. Hard edges for everyone else. Governance is how serious teams scale, not a footnote."
        />
      </Reveal>

      <Reveal delay={80}>
        <ol className="mx-auto mt-12 grid max-w-5xl gap-px overflow-hidden rounded-sm border border-base-line bg-base-line sm:grid-cols-3">
          {CONTROLS.map((control) => (
            <li key={control.id} className="bg-base-850 p-5 text-center">
              <span className="chip-neutral">{control.id}</span>
              <p className="mt-3 text-sm font-bold text-ink">{control.name}</p>
              <p className="mt-1.5 text-sm leading-relaxed text-ink-mute">{control.detail}</p>
            </li>
          ))}
        </ol>
        <div className="mt-8 text-center">
          <Link to="/security" className="btn-ghost px-0">
            Read the security overview →
          </Link>
        </div>
      </Reveal>
    </Section>
  )
}
